import { render, staticRenderFns } from "./ConfirmShipButton.vue?vue&type=template&id=f21ef27a"
import script from "./ConfirmShipButton.vue?vue&type=script&lang=js"
export * from "./ConfirmShipButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports